export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#breaking" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-water-flash-fill text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                吃瓜<span className="text-primary-600">新闻</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              一家以热点为入口的深度内容媒体。用独家专访与深度报道，把热搜背后的事实与逻辑还原清楚。
            </p>
            <div className="mt-4 flex gap-2">
              {['weibo', 'wechat', 'youtube', 'rss'].map((n) => (
                <a
                  key={n}
                  href="#breaking"
                  aria-label={`关注我们 ${n}`}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className={`ri-${n}-line text-lg`} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {/* 栏目导航 */}
          <nav aria-label="页脚栏目导航">
            <h4 className="font-heading text-sm font-bold text-foreground-950">内容栏目</h4>
            <ul className="mt-3 space-y-2">
              {[
                { t: '深度报道', h: '#deep' },
                { t: '独家专访', h: '#interview' },
                { t: '分类快讯', h: '#feed' },
                { t: '吃瓜话题', h: '#topics' },
              ].map((l) => (
                <li key={l.t}>
                  <a href={l.h} className="text-sm text-foreground-700 hover:text-primary-700">
                    {l.t}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 关于 */}
          <nav aria-label="关于我们">
            <h4 className="font-heading text-sm font-bold text-foreground-950">关于我们</h4>
            <ul className="mt-3 space-y-2">
              {[
                { t: '编辑原则', h: '#about' },
                { t: '常见问题', h: '#faq' },
                { t: '订阅频道', h: '#about' },
                { t: '读者口碑', h: '#about' },
              ].map((l) => (
                <li key={l.t}>
                  <a href={l.h} className="text-sm text-foreground-700 hover:text-primary-700">
                    {l.t}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 联系 */}
          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">联系编辑部</h4>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              线索与投稿，欢迎来信。请在邮件中简要说明主题与可提供的素材。
            </p>
            <a
              href="mailto:hello@chiguamag.example"
              className="mt-3 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800"
            >
              <i className="ri-mail-line" aria-hidden="true" /> hello@chiguamag.example
            </a>
            <p className="mt-4 text-xs leading-relaxed text-foreground-600">
              尊重事实 · 克制表达 · 有错必纠
              <br />
              欢迎读者监督与指正。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 吃瓜新闻 · 保留所有权利
          </p>
          <p className="flex items-center gap-3 text-xs text-foreground-600">
            <span>深度报道</span>
            <span className="h-3 w-px bg-background-300" />
            <span>独家专访</span>
            <span className="h-3 w-px bg-background-300" />
            <span>事实核查</span>
          </p>
        </div>
      </div>
    </footer>
  );
}